import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";

document.addEventListener("turbo:load", () => {
  flatpickr("[data-behavior='flatpickr-time-alt']", {
    enableTime: true,
    "locale": Russian,
    disableMobile: true,
    time_24hr: true,
    dateFormat: 'Y-m-d H:i'
  })
})
